import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./App.css";
import { AuthLayout } from "./Components/templates/AuthLayout/AuthLayout";
import MainLayout from "./Components/templates/DashboardLayout/MainLayout";
import { Dashboard } from "./Pages/Dashboard/Dashboard";
import { DoctorsGrid } from "./Pages/Doctors/DoctorsGrid";
import { DummyPage } from "./Pages/DummyPage/DummyPage";
import { DummyPageDoctorportalResetPassword } from "./Pages/DummyPageDoctorportalResetPassword/DummyPageDoctorportalResetPassword";
import { Transactions } from "./Pages/Finance/Accounts/Accounts";
import { ErrorPage } from "./Pages/Misc/NotAuthorised";
import OverView from "./Pages/OverView/OverView";
import { PageNotImplemented } from "./Pages/PageNotImplemented/PageNotImplemented";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import PublicVerification from "./Pages/PublicVerification/PublicVerification";
import { ContactSupport } from "./Pages/Profile/ContactSupport/ContactSupport";
import { RequestResetPassword } from "./Pages/Profile/RequestResetPassword/RequestResetPassword";
import { ResetPassword } from "./Pages/Profile/ResetPassword/ResetPassword";
import { LanguageSelect } from "./Pages/Profile/SignIn/LanguageSelect";
import { Otp } from "./Pages/Profile/SignIn/Otp";
import { Password } from "./Pages/Profile/SignIn/Password";
import { Username } from "./Pages/Profile/SignIn/Username";
import { ResetPasswordSuccessMessage } from "./Pages/ResetPasswordSuccessMessage/ResetPasswordSuccessMessage";
import { Settings } from "./Pages/Settings/Settings";
import { SuccessMessage } from "./Pages/SuccessMessage/SuccessMessage";
import TermsAndConditions from "./Pages/TermsAndConditions/TermsAndConditions";
import { Users } from "./Pages/Users/Users";
import { CheckLanguageSelected } from "./Routes/CheckLanguageSelected";
import { CheckLanguageSelectedResetPassowrd } from "./Routes/CheckLanguageSelectedResetPassowrd";
import RouteRestrict from "./Routes/RouteRestrict";
import {
  ProtectedRoute,
  SignInRoute,
  UnAuthorizedHandler,
  useAuth,
} from "./Store/AuthContext";
import { Permission } from "./Utils/Constant/Permission";
import ComingSoonPage from "./Pages/ComingSoon/ComingSoonPage";
import { PatientsGrid } from "./Pages/Patients/PatientsGrid";
import { DoctorAssistantsGrid } from "./Pages/DoctorAssistants/DoctorAssistantsGrid";
import { Reports } from "./Pages/ReportDetails/Reports";
import { LocationsGrid } from "./Pages/Locations/LocationsGrid";
import { SpecialtiesGrid } from "./Pages/Specialties/SpecialtiesGrid";
import { BannersGrid } from "./Pages/Banners/BannersGrid";

import{ ReportFilters } from "./Pages/ReportDetails/ReportFilters"

function App() {
  const { dispatch, state } = useAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (state?.lang?.code) {
      i18n.changeLanguage(state?.lang?.code);
    }
    dispatch({
      type: "LOADING",
      payload: false,
    });
  }, [state?.lang?.code, state.user]);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route
            path="terms-and-conditions/:lang?"
            element={<TermsAndConditions />}
          />
          <Route path="privacy-notice/:lang?" element={<PrivacyPolicy />} />
         
        </Route>
         <Route path="public-verification" element={<PublicVerification />} />
        <Route path="/signin" element={<AuthLayout />}>
        
          <Route path="/signin" element={<SignInRoute />}>
            <Route element={<CheckLanguageSelected />}>
              <Route path="select-language" element={<LanguageSelect />} />
              <Route path="enter-username" element={<Username />} />
            </Route>
            <Route element={<RouteRestrict />}>
              <Route path="enter-otp" element={<Otp />} />
              <Route path="enter-password" element={<Password />} />
            </Route>
          </Route>
          <Route element={<CheckLanguageSelectedResetPassowrd />}>
            <Route element={<RouteRestrict />}>
              <Route path="forgot-password" element={<RequestResetPassword />} />
              <Route path="reset-password" element={<ResetPassword />} />
            <Route
              path="forgot-password-message"
              element={<SuccessMessage />}
            />
            <Route
              path="reset-password-message"
              element={<ResetPasswordSuccessMessage />}
            />
            </Route>
            
          </Route>
        </Route>
        <Route element={<AuthLayout />}>
          <Route path="contact-support" element={<ContactSupport />} />
        </Route>

        <Route
          path="dummy-reset-password-page"
          element={
            <ProtectedRoute>
              <DummyPageDoctorportalResetPassword />
            </ProtectedRoute>
          }
        />
        <Route
          path="Home"
          element={
            <ProtectedRoute>
              <DummyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route
            path="overview"
            element={
              <UnAuthorizedHandler permission={Permission.overview}>
                <OverView />
              </UnAuthorizedHandler>
            }
          />
          <Route
            path="doctors"
            element={
              <UnAuthorizedHandler permission={Permission.doctors}>
                <DoctorsGrid />
              </UnAuthorizedHandler>
            }
          />
           <Route
            path="doctorsassistants"
            element={
              <UnAuthorizedHandler permission={Permission.doctors}>
                <DoctorAssistantsGrid />
              </UnAuthorizedHandler>
            }
          />
          <Route
            path="patients"
            element={
              <UnAuthorizedHandler permission={Permission.doctors}>
                <PatientsGrid/>
              </UnAuthorizedHandler>
            }
          />
          <Route
            path="locations"
            element={
              <UnAuthorizedHandler permission={Permission.locations}>
                <LocationsGrid/>
              </UnAuthorizedHandler>
            }
          />
          <Route
            path="specialties"
            element={
              <UnAuthorizedHandler permission={Permission.locations}>
                <SpecialtiesGrid/>
              </UnAuthorizedHandler>
            }
          />
          
          <Route path="reports">
            <Route index element={
                <UnAuthorizedHandler permission={Permission.doctors}>
                  <Reports />
                </UnAuthorizedHandler>} />
            <Route path=":reportName">
              <Route path="" element={<ReportFilters />} />
            </Route>
          </Route>

          <Route
            path="banners"
            element={
              <UnAuthorizedHandler permission={Permission.doctors}>
                <BannersGrid/>
              </UnAuthorizedHandler>
            }
          />
          <Route path="Settings" element={<Settings />} />
          <Route
            path="users"
            element={
              <UnAuthorizedHandler permission={Permission.users}>
                <Users />
              </UnAuthorizedHandler>
            }
          />
          <Route path="/finance">
            <Route
              path="transactions"
              element={
                <UnAuthorizedHandler permission={Permission.transaction}>
                  <Transactions />
                </UnAuthorizedHandler>
              }
            />
            <Route
              path="dashboard"
              element={
                <UnAuthorizedHandler permission={Permission.dashboard}>
                  <Dashboard />
                </UnAuthorizedHandler>
              }
            />
            {/* //TODO: need to add payment grid instead dashboardview */}
            <Route
              path="payments"
              element={
                <UnAuthorizedHandler permission={Permission.payments}>
                  <ComingSoonPage />
                </UnAuthorizedHandler>
              }
            />

          </Route>
          {/* not mentioned on the user story TM-91 */}
          {/* <Route path="/settlements" element={<Settlements />} />
          <Route path="/consultations" element={<Consultations />} />
          <Route path="/clients" element={<Clients />} /> */}
        </Route>
        <Route path="/no-access" element={<ErrorPage isAuthorise />} />
        
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
